import {
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableObservableCompletionListener,
    DataTableObservableErrorListener, DataTablePaginatedDataSource,
    DataTablePaginatedRefresher,
    TableAction
} from '@cas-hub/acabim-common-client';
import {ActionDisplayResponse} from '../../_models/action.model';

export class ActionDataSource extends DataTablePaginatedDataSource<ActionDisplayResponse> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name'},
            {displayName: 'Description', objectPropertyName: 'description'},
            {displayName: 'Entity type', objectPropertyName: 'entity_type_display'},
            {displayName: 'Sub-type', objectPropertyName: 'entity_type_subset_display'},
            {displayName: 'Target type', objectPropertyName: 'target_type_display'},
            {displayName: 'Category', objectPropertyName: 'category'},
            {displayName: 'Sub-category', objectPropertyName: 'sub_category'},
            {displayName: 'Repeating', objectPropertyName: 'repeating_display'},
            {displayName: 'Priority', objectPropertyName: 'priority'},
            {displayName: 'Expense type', objectPropertyName: 'expense_type'},
            {displayName: 'Status', objectPropertyName: 'status_display'}
        ];
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [{name: 'Archive', id: 0}];
    silent = false;

    onDataExpanded(value: ActionDisplayResponse): void {}

    constructor(
        readonly actionsInput: TableAction[],
        readonly refresher: DataTablePaginatedRefresher<ActionDisplayResponse>,
        readonly observableErrorListener?: DataTableObservableErrorListener,
        readonly observableCompleteListener?: DataTableObservableCompletionListener,
        readonly actionListener?: (action: TableAction) => void,
        hasDetailButton: boolean = true,
        hasCheckbox: boolean = true,
        tableHeading: string = '',
        colFilters?: ColumnFilter[],
        hasAttachment: boolean = false,
        silent: boolean = false,
    ) {
        super(
            refresher,
            observableErrorListener,
            observableCompleteListener
        );
        this.actions = actionsInput;
        this.silent = silent;
        this.config = {
            tableHeading,
            isSearchEnabled: false,
            searchPlaceHolder: 'Search actions',
            emptyMessage: 'No actions found',
            globalFilterFields: [],
            hasCheckbox,
            hasDetailsButton: hasDetailButton,
            isLazyLoadingEnabled: true,
            isPaginationEnabled: true,
            hasFilters: true,
            isExportEnabled: false,
            hasActions: hasCheckbox,
            datatableUpdateId: 'actions'
        };
        this.columnFilters = colFilters ? colFilters : [];
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }
}
